import React, { useContext } from 'react';

import UserContext from '../UserContext';
import { useLogLogin } from './LoginContractCall';

import { BASE_URL } from '../config';

const multiVACNetwork = {
    chainId: '62621',
    chainName: 'MultiVAC Mainnet',
    nativeCurrency: {
        name: 'MultiVAC',
        symbol: 'MTV',
        decimals: 18,
    },
    rpcUrls: ['https://rpc.mtv.ac'],
    blockExplorerUrls: ['https://e.mtv.ac'],
};

export function useHandleLogin(setLoginStatus, setIsLoggingIn, onLoginSuccess) {
    const { updateUser } = useContext(UserContext);
    const logLogin = useLogLogin();


    const handleLogin = async () => {
        try {
            setIsLoggingIn(true);
            setLoginStatus('Switching network...');

            if (!window.ethereum) {
                setLoginStatus('MetaMask not detected!');
                setIsLoggingIn(false);
                return;
            }

            const hexChainId = `0x${parseInt(multiVACNetwork.chainId).toString(16)}`;
            await window.ethereum.request({
                method: 'wallet_switchEthereumChain',
                params: [{ chainId: hexChainId }],
            });

            setLoginStatus('Getting Wallet...');
            const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
            const account = accounts[0];

            setLoginStatus('Issuing Login TXN');
            const txResult = await logLogin(account);

            const txHash = typeof txResult === "string"
                ? txResult
                : (txResult?.transactionHash || txResult?.hash || "");

            if (!txHash || !txHash.startsWith("0x")) {
                setLoginStatus('Login failed.');
                setIsLoggingIn(false);
                setTimeout(() => setLoginStatus('Awaiting Login...'), 5000);
                return;
            }

            setLoginStatus('Getting clearance...');
            const response = await fetch(`${BASE_URL}/verify_login`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ address: account, txn_hash: txHash })
            });

            let data;
            try {
                data = await response.json();
            } catch (e) {
                data = null;
            }

            // 1. System Updating (check this FIRST)
            if (data && data.update === true) {
                setIsLoggingIn(false);
                setLoginStatus('Updating System...');
                setTimeout(() => setLoginStatus('Awaiting Login...'), 10000);
                return;
            }

            // 2. Login Disabled
            if (!data || (Object.keys(data).length === 0 && response.status === 200)) {
                setIsLoggingIn(false);
                setLoginStatus('Logging in Disabled.');
                setTimeout(() => setLoginStatus('Awaiting Login...'), 10000);
                return;
            }

            // 3. Not Whitelisted
            if (response.status === 403 && data && data.error === "Address not whitelisted.") {
                setIsLoggingIn(false);
                setLoginStatus('Not TestCrew!');
                setTimeout(() => setLoginStatus('Awaiting Login...'), 10000);
                return;
            }

            // 4. BANNED!
            if (response.status === 403 && data && data.error === "BANNED") {
                setIsLoggingIn(false);
                setLoginStatus('BANNED!');
                setTimeout(() => setLoginStatus('Awaiting Login...'), 30000);
                return;
            }

            // 5. NO NFT!
            if (response.status === 403 && data && data.error === "NO NFT") {
                setIsLoggingIn(false);
                setLoginStatus('NO NFT!');
                setTimeout(() => setLoginStatus('Awaiting Login...'), 30000);
                return;
            }

            // 6. Any other 403 error
            if (response.status === 403 && data && data.error) {
                setIsLoggingIn(false);
                setLoginStatus(data.error); // Show the backend error
                setTimeout(() => setLoginStatus('Awaiting Login...'), 10000);
                return;
            }


            // 7. Success
            if (data.login_ok && data.token) {
                updateUser({ wallet_address: account, jwt: data.token });
                setLoginStatus('Login successful!');

                setTimeout(() => {
                    setIsLoggingIn(false);
                    if (onLoginSuccess) onLoginSuccess();
                }, 3000);
            } else {
                setIsLoggingIn(false);
                setLoginStatus('Access Denied...');
                setTimeout(10000);
            }

        } catch (error) {
            console.error(error);
            setIsLoggingIn(false);
            setLoginStatus('Login failed.');
            setIsLoggingIn(false);
            setTimeout(() => setLoginStatus('Awaiting Login...'), 5000);
        }
    };

    return handleLogin;
}
